// Modules
import { observable, extendObservable, action, autorun } from 'mobx';
import firebase from 'firebase';
import 'firebase/firestore';

// Utils
import { findWithProp } from '../utils';

class PinStore {
  constructor() {
    this.resetPinItem();
  }

  @observable editMode = false;
  @observable pinId = '';
  @observable pinList = [];
  @observable categories = {
    competitor: true,
    waterWasteWater: true,
  };

  @action getPins = () => {
    const db = firebase.firestore();
    this.pinUnsubscriber = db.collection('pins')
      .onSnapshot((snapshot) => {
        snapshot.docChanges.forEach((change) => {
          const newPinItem = change.doc.data();
          newPinItem.id = change.doc.id;
          const pinIndex = findWithProp(this.pinList, 'id', newPinItem.id);

          switch (change.type) {
            case 'added':
              console.log('pin');
              this.pinList.push(newPinItem);
              break;
            case 'modified':
              this.pinList[pinIndex] = newPinItem;
              break;
            case 'removed':
              this.pinList.splice(pinIndex, 1);
              break;
            default:
          }
        });
      });
  }

  @action createPin = () => {
    const db = firebase.firestore();
    const pinsRef = db.collection('pins');
    pinsRef.add(this.pinItem).then(() => {
      this.resetPinItem();
    });
  }

  @action resetPinItem = () => {
    extendObservable(this, {
      pinItem: {
        name: '',
        category: '',
        locationId: '',
        lat: '',
        lng: '',
      },
    });
  }

  @action editPinItem = (pinItem, pinId) => {
    this.editMode = true;
    this.pinItem.name = pinItem.name;
    this.pinItem.category = pinItem.category;
    this.pinItem.locationId = pinItem.locationId;
    this.pinItem.lat = pinItem.lat;
    this.pinItem.lng = pinItem.lng;
    this.pinId = pinId;
  }

  @action updatePin = () => {
    const db = firebase.firestore();
    const pinsRef = db.collection('pins').doc(this.pinId);
    pinsRef.update(this.pinItem).then(() => {
      this.cancelEdit();
    });
  }

  @action deletePin = () => {
    const db = firebase.firestore();
    const pinsRef = db.collection('pins').doc(this.pinId);
    pinsRef.delete().then(() => {
      this.cancelEdit();
    });
  }

  @action cancelEdit = () => {
    this.editMode = false;
    this.pinId = '';
    this.resetPinItem();
  }

  @action unsubscribe = () => {
    this.pinList = [];
    if (this.pinUnsubscriber) {
      this.pinUnsubscriber();
    }
  }

  // Debug
  debug = autorun(() => {
    // console.log(this.pinList);
  });
}

const singleton = new PinStore();

export default singleton;



// WEBPACK FOOTER //
// ./src/stores/PinStore.js